// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rtDwtWUing8UI8u0HYHY{color:var(--content-primary-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `rtDwtWUing8UI8u0HYHY`
};
export default ___CSS_LOADER_EXPORT___;
